// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._6VDLU{color:#4cdac9;font-size:.75rem;font-weight:700;letter-spacing:1.5px;text-transform:uppercase}.cxF37,.M7Wi0{display:-webkit-inline-box;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;flex-direction:row-reverse}.cxF37{-webkit-box-pack:end;justify-content:flex-end}.KRPgR{height:21px;margin-left:4px;width:20px}.Tnc_x,.KWDKh{margin-left:0;margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `_6VDLU`,
	"root_instabookCard": `cxF37`,
	"root_listingCard": `M7Wi0`,
	"badge": `KRPgR`,
	"badge_instabookCard": `Tnc_x`,
	"badge_listingCard": `KWDKh`
};
module.exports = ___CSS_LOADER_EXPORT___;
